import PropTypes from 'prop-types';
import Modal from '../Modal/Modal';
import ImgExito from '../../assets/images/Imagen_Mensajes.svg';
import './InfoModal.scss';

const InfoModal = ({ visible, onClose, description }) => {
  const handleOK = () => {
    onClose?.();
  };
  const handleClose = () => {
    onClose?.();
  };
  return (
    <Modal
      title=""
      visible={visible}
      width="38em" // Se establece el tamaño asi por que antd sobreescribe el tamaño que se le pasa por clase
      onCancel={handleClose}
      cancelButtonProps={{ style: { display: 'none' } }}
      okButtonProps={{ style: { display: 'none' } }}
      okText="Generar monitoreo"
      onOk={handleOK}>
      <div className="info-modal">
        <img className="info-modal-imagen" alt="GuardadoCorrecto" src={ImgExito} />
        {description ? (
          <span className="info-modal-descripcion">{description}</span>
        ) : (
          <span className="info-modal-descripcion">El monitoreo se guardó con éxito.</span>
        )}
      </div>
    </Modal>
  );
};

InfoModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  description: PropTypes.string
};

InfoModal.defaultProps = {
  description: null
};

export default InfoModal;
